var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "section" },
    [
      _c("div", { staticClass: "container is-fluid" }, [
        _c("div", { staticClass: "columns is-multiline" }, [
          _c("div", { staticClass: "column is-3 is-2-fullhd" }, [
            _c(
              "div",
              {
                staticClass: "button is-outlined",
                on: {
                  click: function ($event) {
                    _vm.passwordModalVisible = true
                  },
                },
              },
              [
                _c("b-icon", { attrs: { icon: "lock" } }),
                _c("span", [_vm._v("Change password")]),
              ],
              1
            ),
          ]),
        ]),
      ]),
      _c(
        "b-modal",
        {
          attrs: { active: _vm.passwordModalVisible, scroll: "keep" },
          on: {
            "update:active": function ($event) {
              _vm.passwordModalVisible = $event
            },
          },
        },
        [
          _c("PasswordForm", {
            attrs: { "is-submitting": _vm.isSubmitting },
            on: { submit: _vm.submitChangePassword },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }